import { render, staticRenderFns } from "./Fragment.vue?vue&type=template&id=5ee30aea&"
import script from "./Fragment.vue?vue&type=script&lang=ts&"
export * from "./Fragment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ee30aea', component.options)
    } else {
      api.reload('5ee30aea', component.options)
    }
    module.hot.accept("./Fragment.vue?vue&type=template&id=5ee30aea&", function () {
      api.rerender('5ee30aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Fragment.vue"
export default component.exports